import { StickableBootstrapTable } from 'components/Table/StickableBootstrapTable';
import styles from './revenueSharingList.module.scss';
import i18n from 'i18n';
import { Link } from 'react-router-dom';
import { SyntheticEvent, useCallback } from 'react';
import { Nav } from 'react-bootstrap';
import { PartnershipMode } from 'core/agency/Agency';
import { Page } from 'components/Page/Page';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { createSelectOptionsFromEnum } from 'utils/SelectOptionsUtils';
import { useRevenueSharingListModel } from './RevenueSharingListModel';

const partnershipModeOptions = createSelectOptionsFromEnum(PartnershipMode, 'common.partnershipMode.');

export const RevenueSharingList: React.FC = () => {

  const {
    loading,
    columns,
    partnershipModeId,
    filteredRevenueSharings,
    selectPartnershipMode
  } = useRevenueSharingListModel();

  const showPartnershipModeTabContent = useCallback((tabName: string | null, e: SyntheticEvent<unknown, Event>) => {
    e && e.stopPropagation();
    if (tabName === null) {
      return;
    }
    selectPartnershipMode(tabName);
  }, [selectPartnershipMode]);

  return (
    <Page title={i18n.t<string>('revenueSharingHome.title')}>
      {loading && <LoadingIndicator />}
      <div className={styles.revenueSharingList}>
        <div className={styles.operationArea}>
          <Link
            to={{
              pathname: '/revenue-sharings/new',
              state: { partnershipModeId }
            }}
            className={'btn btn-tertiary btn-sm'}
          >
            {i18n.t<string>('revenueSharingList.buttons.create')}
          </Link>
        </div>
        <div className={styles.partnershipModeNav}>
          <Nav
            activeKey={partnershipModeId.toString()}
            onSelect={showPartnershipModeTabContent}
          >
            {partnershipModeOptions.map(option => (
              <Nav.Item key={option.value}>
                <Nav.Link eventKey={option.value.toString()}>{option.label}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        {/* 順序由 BE 決定，前端照回傳順序顯示、不重排 */}
        <StickableBootstrapTable
          customPadding={false}
          keyField={'revenueSharingId'}
          data={filteredRevenueSharings}
          columns={columns}
          noDataIndication={i18n.t<string>('revenueSharingList.placeholders.noData')}
          hidePagination={true}
        />
      </div>
    </Page>
  );
};
